export const WAIVER_MODE = {
  BOOKING: 'booking',
  STANDALONE: 'standalone',
};
